import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LINKS } from '../constants/links';

@Pipe({
  name: 'linkVariable'
})
export class LinkVariablePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(variable: keyof typeof LINKS): SafeUrl {
    const url = LINKS[variable];
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
